import { TFunction } from 'i18next';
import { FolderOption } from 'lib/components/dropdown/folders/customOption';

export const privacy = {
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC',
};

export const getPrivacyOptions = (t: TFunction) => [
  {
    value: privacy.PRIVATE,
    text: t('Private'),
  },
  {
    value: privacy.PUBLIC,
    text: t('Public'),
  },
];

export interface CustomizedState {
  videos: string[];
  category: number;
  targetFolder?: FolderOption;
  title?: string;
  showCounter?: boolean;
  saveText?: string;
}

export interface IOption {
  value: number;
  label: string;
}
export type SelectedGuideCategoryType = {
  guideCategoryId: number;
  name: string;
  guidesCount: number;
  private: boolean;
  isEditable: boolean;
  platform: GUIDE_CATEGORY_PLATFORM;
} | null;

export enum GUIDE_CATEGORY_PLATFORM {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
  BOTH = 'both',
}
